import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Table, Button, Form, Input, Collapse, Select } from "antd";
import Popup from "../Popup";
import "../../styles/components/approverForm.scss";

import { showPopup, hidePopup } from "../../state/slices/generalSlice";
import ViewingForm from "../Form/ViewingForm";

function SpectatorTable({
  tableColumn,
  tableData,
  popupSlice,
  popupName,
  popupWidth,
  docuType,
  addtnlContent,
  viewingDataConfig,
}) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState([]);

  const handleRowClick = (record) => {
    setFormData(record);
    dispatch(showPopup(popupName));
  };

  return (
    <>
      <div className="approve">
        <Table
          columns={tableColumn}
          dataSource={tableData}
          size="small"
          rowKey={(record) => record.id || record.key}
          onRow={(record) => ({
            onClick: () => handleRowClick(record),
          })}
          className="approve-table"
        />
        <Popup
          isOpen={popupSlice}
          title={docuType + " Form"}
          onCancel={() => {
            dispatch(hidePopup(popupName));
          }}
          footer={null}
          className="approve-popup"
          width={popupWidth}
        >
          {typeof addtnlContent === "function" && addtnlContent(formData)}
          <ViewingForm viewingDataConfig={viewingDataConfig} data={formData} />
        </Popup>
      </div>
    </>
  );
}

export default SpectatorTable;
